import { gql } from '@apollo/client';

export const LOCAL_SCHEMA = gql`
  directive @client on FIELD

  extend type Query {
    user: User!
    nameProject: String
  }
`;
